/* __next_internal_client_entry_do_not_use__ ProductTileContainerRefContextProvider,useProductTileContainerRef auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
/**
 * Use this component if your tile needs to ref to container's css props.
 * e.g. absolute position for components overlays on image.
 */ export var ProductTileContainerRefContextProvider = function(param) {
    var children = param.children;
    var containerRef = useRef(null);
    return /*#__PURE__*/ _jsx(ProductTileContainerRefContext.Provider, {
        value: containerRef,
        children: children
    });
};
export var useProductTileContainerRef = function() {
    return React.useContext(ProductTileContainerRefContext);
};
var ProductTileContainerRefContext = /*#__PURE__*/ React.createContext(null);
